module.exports = __webpack_public_path__ + "img/JobSeeker.5e93241c.svg";